var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 60 60",
    fill: "#260e00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001,47.3293c-7.1426,0-12.9531-5.8115-12.9531-12.9541s5.8105-12.9531,12.9531-12.9531,12.9531,5.8105,12.9531,12.9531-5.8105,12.9541-12.9531,12.9541ZM50.0001,24.8245c-5.2666,0-9.5508,4.2842-9.5508,9.5508s4.2842,9.5518,9.5508,9.5518,9.5508-4.2852,9.5508-9.5518-4.2842-9.5508-9.5508-9.5508Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5157,78.5774c-.9395,0-1.7012-.7617-1.7012-1.7012,0-12.0283-9.7861-21.8135-21.8145-21.8135s-21.8145,9.7852-21.8145,21.8135c0,.9395-.7617,1.7012-1.7012,1.7012s-1.7012-.7617-1.7012-1.7012c0-13.9043,11.3125-25.2158,25.2168-25.2158s25.2168,11.3115,25.2168,25.2158c0,.9395-.7617,1.7012-1.7012,1.7012Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomProfile);
export default __webpack_public_path__ + "static/media/custom_profile.137cc74cdd066f352bc9545d19742910.svg";
export { ForwardRef as ReactComponent };